import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
import { MiniCompany } from '@fullyops/data/companies/mini-company';
import { Contact, ContactInput } from '@fullyops/data/contacts/contact';
import { ArrowComponent } from '@fullyops/shared/components/arrow/component';
import { AutocompletingSelectComponent } from '@fullyops/shared/components/autocompleting-select/component';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextCapPipe } from 'angular-i18next';
import { Observable } from 'rxjs';

@Component({
  selector: 'fo-contact-form',
  imports: [
    MaterialModule,
    RouterModule,
    ReactiveFormsModule,
    AutocompletingSelectComponent,
    ArrowComponent,
    I18NextCapPipe,
  ],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss',
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', floatLabel: 'always' },
    },
  ],
})
export class ContactFormComponent implements OnInit {
  @Input() initialValue?: Contact;
  @Input() companyDisabled = false;
  @Input() disabled = false;
  @Input() companies$: Observable<MiniCompany[]>;
  @Output() onSave = new EventEmitter<ContactInput>();

  ngOnInit(): void {
    if (this.initialValue != null) {
      this.formGroup.patchValue(this.initialValue, { emitEvent: false });
    }
    if (this.disabled) {
      this.formGroup.disable({ emitEvent: false });
    }
    if (this.companyDisabled) {
      this.formGroup.controls.company.disable({ emitEvent: false });
    }
  }

  protected formGroup = new FormGroup({
    name: new FormControl('', {
      nonNullable: true,
      validators: Validators.required,
    }),
    jobPosition: new FormControl('', { nonNullable: true }),
    address: new FormControl('', { nonNullable: true }),
    email: new FormControl('', {
      nonNullable: true,
      validators: Validators.email,
    }),
    mobileNumber: new FormControl('', { nonNullable: true }),
    company: new FormControl<{ id: string }>(null, Validators.required),
    notes: new FormControl('', { nonNullable: true }),
  });

  protected onClickSave(): void {
    const { company, ...v } = this.formGroup.getRawValue();
    this.onSave.next({ ...v, companyId: company.id });
  }
}
